module.exports = __webpack_public_path__ + "media/images/bnr-summer-sale-sm-93a1f4955a785e85ee59bb1b0d2ecc4c.png";